module.exports = __webpack_public_path__ + "static/media/langtools.c476e669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/langtools.jpg
// module id = 132
// module chunks = 0